export class DiagnosticResult {
    constructor() {
        this.DeviceGuid = "";
        this.DeviceDiagnosticsStatus = DeviceDiagnosticsStatus.Unknown;
        this.CanBeFixed = false;
    }
}
export var DeviceDiagnosticsStatus;
(function (DeviceDiagnosticsStatus) {
    DeviceDiagnosticsStatus[DeviceDiagnosticsStatus["Unknown"] = 0] = "Unknown";
    DeviceDiagnosticsStatus[DeviceDiagnosticsStatus["Healthy"] = 1] = "Healthy";
    DeviceDiagnosticsStatus[DeviceDiagnosticsStatus["Unpaired"] = 2] = "Unpaired";
    DeviceDiagnosticsStatus[DeviceDiagnosticsStatus["FirmwareUpdateMode"] = 3] = "FirmwareUpdateMode";
    DeviceDiagnosticsStatus[DeviceDiagnosticsStatus["NotResponding"] = 4] = "NotResponding";
    DeviceDiagnosticsStatus[DeviceDiagnosticsStatus["NotSupported"] = 5] = "NotSupported";
})(DeviceDiagnosticsStatus || (DeviceDiagnosticsStatus = {}));
export var DiagnosticErrorCode;
(function (DiagnosticErrorCode) {
    DiagnosticErrorCode["Success"] = "Success";
    DiagnosticErrorCode["CannotFindDevice"] = "CannotFindDevice";
    DiagnosticErrorCode["OtherError"] = "OtherError";
    DiagnosticErrorCode["FatalError"] = "FatalError";
    DiagnosticErrorCode["DeviceRepairFailed"] = "DeviceRepairFailed";
    DiagnosticErrorCode["RepairingIsUnsupported"] = "RepairingIsUnsupported";
})(DiagnosticErrorCode || (DiagnosticErrorCode = {}));
//# sourceMappingURL=DiagnosticParams.js.map